// extracted by mini-css-extract-plugin
module.exports = {"container":"WhyPlayItaly_container__N_LZU","cardSlide":"WhyPlayItaly_cardSlide__2GeXD","carouselContainer":"WhyPlayItaly_carouselContainer__HNHgJ"};